import { c as _c } from "react/compiler-runtime";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { InviteMemberButton } from "@components/common/invite-member-button";
import { createMemberOption, createTeamOption } from "@components/common/members-autocomplete/members-autocomplete-utils";
import { EnableGroupCreationCheckbox } from "@components/groups/enable-group-creation-checkbox";
import { SelectGroupRole } from "@components/role/select-group-role";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { Dialog } from "@flat-ui";
import { useMembersAutocomplete } from "@hooks/autocomplete/use-members-autocomplete";
import { useCompanyMembers } from "@hooks/use-company-members";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useRespondToInvite } from "@hooks/use-respond-to-invite";
import { Stack } from "@mui-wrapper";
import { useAppParams } from "@router/router-helper";
import { useCompanyId } from "@context-providers/company-id-provider";
import { INVITE_DIALOG_CLOSE_DELAY_MS } from "@src/constants/invite-constants";
import { selectedGroupMembersSelector } from "@store/groups/groups-selector";
import { addProcessingGroups, removeProcessingGroups, setOne } from "@store/groups/groups-slice";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { assignableTeamsSelector } from "@store/teams/teams-selector";
import { delay } from "@utils/time-utils";
import { GroupMemberEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { createGroupsPermission } from "@utils/user-utils";
import { useCallback, useMemo, useState } from "react";
import { useTeamUtils } from "@hooks/use-team-utils";
import { sortMembersByNameOrEmail } from "@utils/member-utils";
import { sortTeams } from "@utils/team-utils";
import { MembersAutocomplete } from "@components/common/members-autocomplete/members-autocomplete";
import { shouldDisableSendInvite } from "@utils/members-invite-utils";
import { UtilsTypes } from "@stellar/utils";
/** Renders the invite member button and the functionality in member page */
export function InviteMemberToGroup(t0) {
  const $ = _c(71);
  const {
    group,
    buttonVariant
  } = t0;
  const dispatch = useAppDispatch();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    groupId
  } = useAppParams();
  const companyId = useCompanyId();
  const {
    respondToUser
  } = useRespondToInvite();
  const {
    isTeamName
  } = useTeamUtils();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const companyMembers = useCompanyMembers();
  const teams = useAppSelector(assignableTeamsSelector);
  const groupMembers = useAppSelector(selectedGroupMembersSelector);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [shouldCreateGroups, setShouldCreateGroups] = useState(false);
  const [selectedRole, setSelectedRole] = useState("PROJECT_MANAGER");
  const roleToAssign = canAssignManagers ? selectedRole : "GROUP_VIEWER";
  let t1;
  if ($[0] !== groupMembers) {
    t1 = id => groupMembers.find(groupMember => id === groupMember.identity);
    $[0] = groupMembers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isAlreadyInGroup = t1;
  let t2;
  if ($[2] !== companyMembers || $[3] !== isAlreadyInGroup) {
    let t3;
    if ($[5] !== isAlreadyInGroup) {
      t3 = member => {
        const memberInGroup = isAlreadyInGroup(member.identity);
        const isMemberInGroup = !!memberInGroup;
        return createMemberOption({
          member,
          isDisabled: isMemberInGroup,
          disabledMessage: isMemberInGroup ? `Already in group ${memberInGroup?.role ? `as ${UtilsTypes.RoleDisplayNames[memberInGroup?.role]}` : ""}` : ""
        });
      };
      $[5] = isAlreadyInGroup;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = sortMembersByNameOrEmail(companyMembers).map(t3);
    $[2] = companyMembers;
    $[3] = isAlreadyInGroup;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const memberOptions = t2;
  let t3;
  if ($[7] !== isAlreadyInGroup || $[8] !== teams) {
    let t4;
    if ($[10] !== isAlreadyInGroup) {
      t4 = team => {
        const teamInGroup = isAlreadyInGroup(team.id);
        const isTeamInGroup = !!teamInGroup;
        return createTeamOption({
          team,
          isDisabled: isTeamInGroup,
          disabledMessage: isTeamInGroup ? `Already in group ${teamInGroup?.role ? `as ${UtilsTypes.RoleDisplayNames[teamInGroup?.role]}` : ""}` : ""
        });
      };
      $[10] = isAlreadyInGroup;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = sortTeams(teams, "name_ascending").map(t4);
    $[7] = isAlreadyInGroup;
    $[8] = teams;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const teamOptions = t3;
  let t4;
  if ($[12] !== memberOptions || $[13] !== teamOptions) {
    t4 = [...teamOptions, ...memberOptions];
    $[12] = memberOptions;
    $[13] = teamOptions;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const autocompleteOptions = t4;
  const t5 = group.members;
  let t6;
  if ($[15] !== companyMembers) {
    t6 = companyMembers.map(_temp);
    $[15] = companyMembers;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== autocompleteOptions || $[18] !== group.members || $[19] !== t6) {
    t7 = {
      entityName: "group",
      existingMembers: t5,
      options: autocompleteOptions,
      companyMemberIds: t6
    };
    $[17] = autocompleteOptions;
    $[18] = group.members;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const {
    selectedMembers,
    selectedValues,
    uniqueSelectedValues,
    helperText,
    isMemberInputValid,
    handleMemberSelect,
    onInputChange,
    isNewEmailValid,
    reset
  } = useMembersAutocomplete(t7);
  let t8;
  if ($[21] !== isMemberInputValid || $[22] !== uniqueSelectedValues) {
    t8 = shouldDisableSendInvite(uniqueSelectedValues, isMemberInputValid);
    $[21] = isMemberInputValid;
    $[22] = uniqueSelectedValues;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const shouldSendInviteDisable = t8;
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = async function closeDialog() {
      setIsDialogOpen(false);
      await delay(INVITE_DIALOG_CLOSE_DELAY_MS);
      setIsLoading(false);
    };
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const closeDialog = t9;
  let handleConfirm;
  if ($[25] !== companyId || $[26] !== dispatch || $[27] !== group || $[28] !== groupId || $[29] !== handleErrorWithToast || $[30] !== respondToUser || $[31] !== roleToAssign || $[32] !== shouldCreateGroups || $[33] !== trackEvent || $[34] !== uniqueSelectedValues) {
    handleConfirm = async function handleConfirm() {
      setIsLoading(true);
      trackEvent({
        name: GroupMemberEvents.inviteMembers,
        props: {
          numberOfMembers: uniqueSelectedValues.length,
          role: roleToAssign
        }
      });
      ;
      try {
        await createPayloadAndSendInvite();
        closeDialog();
      } catch (t10) {
        const error = t10;
        setIsLoading(false);
        handleErrorWithToast({
          id: `inviteMember-${Date.now().toString()}`,
          title: "Cannot invite member(s)",
          error
        });
      }
    };
    async function createPayloadAndSendInvite() {
      const permission = shouldCreateGroups && roleToAssign === "COMPANY_MANAGER" ? createGroupsPermission : undefined;
      const payload = {
        assignments: [{
          identities: uniqueSelectedValues,
          permission,
          role: roleToAssign
        }]
      };
      if (groupId && uniqueSelectedValues.length) {
        dispatch(addProcessingGroups([groupId]));
        const response = await faroCoreApiClient.groups.addMembersToGroup({
          companyId,
          groupId,
          payload
        });
        if (response.data.members) {
          const groupWithUpdatedMembers = {
            ...group,
            members: response.data.members
          };
          dispatch(setOne(groupWithUpdatedMembers));
        }
        dispatch(removeProcessingGroups([groupId]));
        respondToUser(response, uniqueSelectedValues.length);
      }
    }
    $[25] = companyId;
    $[26] = dispatch;
    $[27] = group;
    $[28] = groupId;
    $[29] = handleErrorWithToast;
    $[30] = respondToUser;
    $[31] = roleToAssign;
    $[32] = shouldCreateGroups;
    $[33] = trackEvent;
    $[34] = uniqueSelectedValues;
    $[35] = handleConfirm;
  } else {
    handleConfirm = $[35];
  }
  let t10;
  if ($[36] !== reset) {
    t10 = function onOpenInviteDialog() {
      reset();
      setIsDialogOpen(true);
    };
    $[36] = reset;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  const onOpenInviteDialog = t10;
  let t11;
  if ($[38] !== buttonVariant || $[39] !== onOpenInviteDialog) {
    t11 = <InviteMemberButton buttonVariant={buttonVariant} onClick={onOpenInviteDialog} />;
    $[38] = buttonVariant;
    $[39] = onOpenInviteDialog;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  const t12 = canAssignManagers ? "Invite members to group" : "Invite viewers to group";
  let t13;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setIsDialogOpen(false);
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  let t14;
  if ($[42] !== canAssignManagers || $[43] !== selectedRole) {
    t14 = canAssignManagers && <Stack sx={{
      marginBottom: SPACE_ELEMENTS_OF_MODAL
    }}><SelectGroupRole selectedRole={selectedRole} onChange={setSelectedRole} variant="outlined" /></Stack>;
    $[42] = canAssignManagers;
    $[43] = selectedRole;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== isNewEmailValid || $[46] !== isTeamName) {
    t15 = value => isNewEmailValid(value) || isTeamName(value);
    $[45] = isNewEmailValid;
    $[46] = isTeamName;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== autocompleteOptions || $[49] !== handleMemberSelect || $[50] !== helperText || $[51] !== onInputChange || $[52] !== selectedMembers || $[53] !== t15) {
    t16 = <Stack><MembersAutocomplete isRequired={true} hasAutoFocus={true} label="Members" helperText={helperText} options={autocompleteOptions} onInputChange={onInputChange} selectedOptions={selectedMembers} handleMemberSelect={handleMemberSelect} isValid={t15} /></Stack>;
    $[48] = autocompleteOptions;
    $[49] = handleMemberSelect;
    $[50] = helperText;
    $[51] = onInputChange;
    $[52] = selectedMembers;
    $[53] = t15;
    $[54] = t16;
  } else {
    t16 = $[54];
  }
  let t17;
  if ($[55] !== roleToAssign || $[56] !== selectedValues.length || $[57] !== shouldCreateGroups) {
    t17 = <EnableGroupCreationCheckbox selectedRole={roleToAssign} shouldCreateGroups={shouldCreateGroups} membersCount={selectedValues.length} setShouldCreateGroups={setShouldCreateGroups} />;
    $[55] = roleToAssign;
    $[56] = selectedValues.length;
    $[57] = shouldCreateGroups;
    $[58] = t17;
  } else {
    t17 = $[58];
  }
  let t18;
  if ($[59] !== handleConfirm || $[60] !== isDialogOpen || $[61] !== isLoading || $[62] !== shouldSendInviteDisable || $[63] !== t12 || $[64] !== t14 || $[65] !== t16 || $[66] !== t17) {
    t18 = <Dialog title={t12} confirmText="Send Invite" open={isDialogOpen} onConfirm={handleConfirm} showSpinner={isLoading} isConfirmDisabled={shouldSendInviteDisable} onCancel={t13}>{t14}{t16}{t17}</Dialog>;
    $[59] = handleConfirm;
    $[60] = isDialogOpen;
    $[61] = isLoading;
    $[62] = shouldSendInviteDisable;
    $[63] = t12;
    $[64] = t14;
    $[65] = t16;
    $[66] = t17;
    $[67] = t18;
  } else {
    t18 = $[67];
  }
  let t19;
  if ($[68] !== t11 || $[69] !== t18) {
    t19 = <>{t11}{t18}</>;
    $[68] = t11;
    $[69] = t18;
    $[70] = t19;
  } else {
    t19 = $[70];
  }
  return t19;
}
function _temp(member_0) {
  return member_0.identity;
}